import { formatRoleName } from '../../../common';
import { formatScopeName, formatViewName, getRoleNames, getScopeName, getViewName } from '../../utils/nameFormat';
import { createStructureStatementHandler } from "../../createStructureStatementHandler";
const articleList = getViewName({ entityName: 'Article', viewType: 'dataGrid' });
const articleScope = getScopeName({ entityName: 'Article' });
export const aclDenyScopeStmtInstruction = `
#### Denying access to entities

- Syntax: \`deny <role1>[, <role2>] scope <viewName>.<scopeName>;\`
- Example: \`deny ${getRoleNames('user')} scope ${articleList}.${articleScope};\`
- Example: \`deny ${getRoleNames('editor')} scope ${articleList}.${articleScope};\`
- Example: \`deny ${getRoleNames('public', 'editor')} scope ${articleList}.${articleScope};\`
`;
export const stmtAclDenyScope = ({ roles, viewName, scopeName }) => {
    return `deny ${roles.join(', ')} scope ${viewName}.${scopeName};`;
};
export const aclDenyScopeHandler = createStructureStatementHandler({
    type: 'deny scope',
    parse: line => {
        const match = /^deny (?<roles>[\w, ]+) scope (?<viewName>\w+).(?<scopeName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'deny scope',
                roles: match.groups.roles.split(',').map(it => formatRoleName(it.trim())),
                viewName: formatViewName(match.groups.viewName),
                scopeName: formatScopeName(match.groups.scopeName),
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => it.denyScope({ roles: stmt.roles, scopeName: stmt.scopeName, viewName: stmt.viewName }));
    },
});
//# sourceMappingURL=DenyRoleScopeStmt.js.map